import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import classNames from "classnames"
import Button from "../../components/button/button"
import Background from "../parts/background/background.js"

const PageTitle = ({ blok, pageInfo }) => {
  return (
    <section
      className={classNames("block_page_title content_block", {
        "collapse-bottom": blok?.collapse_bottom_padding,
      })}
      {...storyblokEditable(blok)}
      key={blok?._uid}
    >
      {blok?.background_settings && (
        <Background blok={blok.background_settings} />
      )}
      <div className="inner">
        <div className="title-container gs_reveal">
          <h1>{blok?.page_title || pageInfo?.name}</h1>
          {blok?.value_prop && <p className="value-prop">{blok?.value_prop}</p>}
        </div>

        {pageInfo?.meta && (
          <div className="title-meta gs_reveal">
            {pageInfo.meta.date_formatted && (
              <span className="meta-date">{pageInfo.meta.date_formatted}</span>
            )}
            {pageInfo.meta.media_outlet && (
              <span className="meta-date">{pageInfo.meta.media_outlet}</span>
            )}

            {pageInfo.meta.resource_type && (
              <span className="meta-resource_type">
                {pageInfo.meta.resource_type}
              </span>
            )}

            {pageInfo.meta.button_label ? (
              <div className="cta_container">
                <span className="button tertiary url">
                  <span>{pageInfo.meta.button_label}</span>
                </span>
              </div>
            ) : (
              <React.Fragment>
                {(pageInfo.meta.external_link?.id ||
                  pageInfo.meta.external_link?.url) && (
                  <Button
                    blok={{
                      Style: "tertiary",
                      Label: pageInfo.meta.button_label
                        ? pageInfo.meta.button_label
                        : "Read the Full Story",
                      content_target: pageInfo.meta.external_link,
                    }}
                  />
                )}
              </React.Fragment>
            )}
          </div>
        )}
      </div>
    </section>
  )
}

export default PageTitle
